const config = {
  phone: ' +49 (0)89 80990788-0',
  opening: 'Mo-Fr. 9-12 Uhr und 16-19 Uhr',
  endpoint: 'https://assets.5-anker.com',
  planbar24_url: 'https://portal.chartercheck.com',
  channel: 'cc',
  ccm19ScriptSrc: 'https://cloud.ccm19.de/app.js?apiKey=88fb1c5cfd7df1d004c8916a3f14efe79248a06db6fcb289&domain=69f1c537091ff0421f07e553',
  primarySearchPage: '/yachtcharter',
  social: {
    facebook: 'https://www.facebook.com/chartercheckcom',
  },
  // ids of multinational regions like Mittelmeer, Nordsee and unsupported countries like russia etc..
  regionIdsToHide: [],
};

export default config;
